import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-print-btn-toggle',
  templateUrl: './print-btn-toggle.component.html',
  styleUrls: ['./print-btn-toggle.component.scss'],
})
export class PrintBtnToggleComponent implements OnInit {
  @Input('disabled') disabled: boolean = false;
  @Input('default') default: 'oneSide' | 'twoSide' = 'oneSide';

  // When user selects any value.
  @Output('change') change = new EventEmitter<'oneSide' | 'twoSide'>();

  constructor() {}
  ngOnInit(): void {}
  ngAfterViewInit() {
    this.change.emit(this.default);
  }

  emitChangeEvent() {
    this.change.emit(this.default);
  }

  select(selected: 'oneSide' | 'twoSide') {
    this.default = selected;
    this.emitChangeEvent();
  }
}
